import {
    Flex,
    GridItem,
    Text,
} from '@chakra-ui/react';

interface StatBoxProps {
    label: string;
    value: string | number;
    subValue?: string;
}

const StatBox = ({ label, value, subValue }: StatBoxProps) => (
    <GridItem h="100%">
        <Flex
            direction="column"
            h="100%"
            bg="white"
            p={3}
            borderRadius="lg"
            borderWidth="1px"
            borderColor="gray.200"
            boxShadow="none"
        >
            <Text
                fontSize="xs"
                color="gray.500"
                fontWeight="bold"
                letterSpacing="wide"
                mb={1}
                textTransform="uppercase"
            >
                {label}
            </Text>
            {subValue ? (
                <>
                    <Text
                        fontSize="lg"
                        fontWeight="bold"
                        color="gray.900"
                        mt="auto"
                    >
                        {value}
                    </Text>
                    <Text fontSize="xs" color="gray.500">
                        {subValue}
                    </Text>
                </>
            ) : (
                <Flex flex={1} align="center">
                    <Text
                        fontSize="lg"
                        fontWeight="bold"
                        color="gray.900"
                    >
                        {value}
                    </Text>
                </Flex>
            )}
        </Flex>
    </GridItem>
);

export default StatBox;
